<template>
  <div class="form-grid">
    <div class="form-item">
      <label class="form-label required">廣告名稱</label>
      <el-input v-model="form.name" placeholder="請輸入廣告名稱"/>
    </div>
    <div class="form-item">
      <label class="form-label required">排序</label>
      <el-input-number v-model="form.sort" :min="0" :controls="false"/>
    </div>

    <div class="form-item full">
      <label class="form-label required">投放位置</label>
      <el-checkbox-group v-if="!form.id" v-model="form.positionList" class="position-list">
        <el-checkbox v-for="p in positions" :key="p.dictValue" :label="p.dictValue">
          <span>{{ p.dictLabel }}</span>
          <small v-if="p.remark">（{{ p.remark }}）</small>
        </el-checkbox>
      </el-checkbox-group>
      <el-radio-group v-else v-model="form.position" class="position-list">
        <el-radio v-for="p in positions" :key="p.dictValue" :label="p.dictValue">
          <span>{{ p.dictLabel }}</span>
          <small v-if="p.remark">（{{ p.remark }}）</small>
        </el-radio>
      </el-radio-group>
    </div>

    <div class="form-item full notice">
      <i class="el-icon-info"/>
      <span>{{ form.id ? '編輯時僅能調整單一投放位置。' : '多選投放位置後，系統將依位置拆分為多筆廣告資料。' }}</span>
    </div>

    <upload-box label="共用 PC 圖" box-title="PC 主圖" detail="1920 × 560 px" :value="form.pcImage"
                @upload="upload($event,'pcImage')"/>
    <upload-box label="共用 WAP 圖" box-title="WAP 主圖" detail="750 × 420 px" :value="form.wapImage"
                @upload="upload($event,'wapImage')"/>

    <div class="form-item">
      <label class="form-label">外鏈</label>
      <el-input v-model="form.externalUrl" placeholder="https://"/>
    </div>
    <div class="form-item">
      <label class="form-label required">狀態</label>
      <el-select v-model="form.status">
        <el-option label="有效" value="0"/>
        <el-option label="關閉" value="1"/>
      </el-select>
    </div>

    <div class="form-item full">
      <label class="form-label">介紹</label>
      <el-input v-model="form.introduction" type="textarea" :rows="3" placeholder="請輸入廣告介紹"/>
    </div>

    <div class="form-item">
      <label class="form-label required">開始日期</label>
      <el-date-picker v-model="form.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"/>
    </div>
    <div class="form-item">
      <label class="form-label required">結束日期</label>
      <el-date-picker v-model="form.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"/>
    </div>
  </div>
</template>

<script>
import UploadBox from './UploadBox.vue';

export default {
  components: {UploadBox},
  props: {
    form: {type: Object, required: true},
    positions: {type: Array, default: () => []},
    upload: {type: Function, required: true}
  }
}
</script>
